import styled from 'styled-components/macro'

export const Layer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 0; /* placed and sized by the component while open */
  z-index: 99;
  background: ${props => props.theme.backdrop};
  transition: opacity 0.25s ease-in-out;

  &.closed {
    pointer-events: none;
    opacity: 0;
  }
`
